export const Icon_User = () => <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_0_2440)">
        <path
            d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z"
            fill="#01A3D4"/>
    </g>
    <defs>
        <clipPath id="clip0_0_2440">
            <rect width={24} height={24} fill="white"/>
        </clipPath>
    </defs>
</svg>


export const Icon_Location = () => <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_0_2447)">
        <path
            d="M12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z"
            fill="#01A3D4"/>
    </g>
    <defs>
        <clipPath id="clip0_0_2447">
            <rect width={24} height={24} fill="white"/>
        </clipPath>
    </defs>
</svg>


export const Icon_Shop = () =>
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_0_2454)">
            <path
                d="M18.36 9L18.96 12H5.04L5.64 9H18.36ZM20 4H4V6H20V4ZM20 7H4L3 12V14H4V20H14V14H18V20H20V14H21V12L20 7ZM6 18V14H12V18H6Z"
                fill="#01A3D4"/>
        </g>
        <defs>
            <clipPath id="clip0_0_2454">
                <rect width={24} height={24} fill="white"/>
            </clipPath>
        </defs>
    </svg>


export const Icon_inventory = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_0_2461)">
        <path
            d="M19 6H17C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6H5C3.9 6 3 6.9 3 8V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V8C21 6.9 20.1 6 19 6ZM12 3C13.66 3 15 4.34 15 6H9C9 4.34 10.34 3 12 3ZM19 20H5V8H19V20ZM12 12C10.34 12 9 10.66 9 9H7C7 11.76 9.24 14 12 14C14.76 14 17 11.76 17 9H15C15 10.66 13.66 12 12 12Z"
            fill="#01A3D4"/>
    </g>
    <defs>
        <clipPath id="clip0_0_2461">
            <rect width="24" height="24" fill="white"/>
        </clipPath>
    </defs>
</svg>

//InsuranceInsurance


export const Icon_Insurance = () => <svg width={18} height={22} viewBox="0 0 18 22" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9 0L0 4V10C0 15.55 3.84 20.74 9 22C14.16 20.74 18 15.55 18 10V4L9 0ZM16 10C16 14.52 13.02 18.69 9 19.93C4.98 18.69 2 14.52 2 10V5.3L9 2.19L16 5.3V10ZM4.41 10.59L3 12L7 16L15 8L13.59 6.58L7 13.17L4.41 10.59Z"
        fill="#01A3D4"/>
</svg>


export const Icon_Packaging_and_label = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                   xmlns="http://www.w3.org/2000/svg">
    <path
        d="M21 16.5C21 16.88 20.79 17.21 20.47 17.38L12.57 21.82C12.41 21.94 12.21 22 12 22C11.79 22 11.59 21.94 11.43 21.82L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L11.43 2.18C11.59 2.06 11.79 2 12 2C12.21 2 12.41 2.06 12.57 2.18L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5ZM12 4.15L10.11 5.22L16 8.61L17.96 7.5L12 4.15ZM6.04 7.5L12 10.85L13.96 9.75L8.08 6.35L6.04 7.5ZM5 15.91L11 19.29V12.58L5 9.21V15.91ZM19 15.91V9.21L13 12.58V19.29L19 15.91Z"
        fill="#01A3D4"/>
</svg>


export const Icon_Quality_Control = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                               xmlns="http://www.w3.org/2000/svg">
    <path
        d="M21 16.5C21 16.88 20.79 17.21 20.47 17.38L12.57 21.82C12.41 21.94 12.21 22 12 22C11.79 22 11.59 21.94 11.43 21.82L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L11.43 2.18C11.59 2.06 11.79 2 12 2C12.21 2 12.41 2.06 12.57 2.18L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5ZM12 4.15L10.11 5.22L16 8.61L17.96 7.5L12 4.15ZM6.04 7.5L12 10.85L13.96 9.75L8.08 6.35L6.04 7.5ZM5 15.91L11 19.29V12.58L5 9.21V15.91ZM19 15.91V9.21L13 12.58V19.29L19 15.91Z"
        fill="#01A3D4"/>
</svg>


export const Icon_Transportation = () => <svg width={24} height={24} viewBox="0 0 24 24" fill="none"
                                              xmlns="http://www.w3.org/2000/svg">
    <path
        d="M20 8H17V4H1V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM6 18.5C5.17 18.5 4.5 17.83 4.5 17C4.5 16.17 5.17 15.5 6 15.5C6.83 15.5 7.5 16.17 7.5 17C7.5 17.83 6.83 18.5 6 18.5ZM15 7H13V14H11V7H9V14H7V7H5V14H3V6H15V7ZM18 18.5C17.17 18.5 16.5 17.83 16.5 17C16.5 16.17 17.17 15.5 18 15.5C18.83 15.5 19.5 16.17 19.5 17C19.5 17.83 18.83 18.5 18 18.5ZM17 12V9.5H19.5L21.46 12H17Z"
        fill="#01A3D4"/>
</svg>


export const Icon_Customs_formalities = () => <svg width={20} height={22} viewBox="0 0 20 22" fill="none"
                                                   xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4 5H16V8.96L10 7L4 8.96M1.94 18H2C3.6 18 5 17.12 6 16C7 17.12 8.4 18 10 18C11.6 18 13 17.12 14 16C15 17.12 16.4 18 18 18H18.05L19.95 11.31C20.03 11.06 20 10.78 19.89 10.54C19.76 10.3 19.55 10.12 19.29 10.04L18 9.62V5C18 3.89 17.1 3 16 3H13V0H7V3H4C3.46957 3 2.96086 3.21071 2.58579 3.58579C2.21071 3.96086 2 4.46957 2 5V9.62L0.71 10.04C0.45 10.12 0.24 10.3 0.11 10.54C-1.04308e-07 10.78 -0.03 11.06 0.05 11.31M18 20C16.61 20 15.22 19.53 14 18.67C11.56 20.38 8.44 20.38 6 18.67C4.78 19.53 3.39 20 2 20H0V22H2C3.37 22 4.74 21.65 6 21C8.5 22.3 11.5 22.3 14 21C15.26 21.65 16.62 22 18 22H20V20H18Z"
        fill="#01A3D4"/>
</svg>


export const Icon_singpro_Authenticated = () => <svg width={19} height={19} viewBox="0 0 19 19" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_0_2846)">
        <path
            d="M9.79635 1.36499L3.16797 4.31094V8.72986C3.16797 12.8174 5.99608 16.6397 9.79635 17.5677C13.5966 16.6397 16.4247 12.8174 16.4247 8.72986V4.31094L9.79635 1.36499ZM8.32337 13.1488L5.37743 10.2028L6.41587 9.16438L8.32337 11.0645L13.1768 6.21107L14.2153 7.25688L8.32337 13.1488Z"
            fill="#01A3D4"/>
    </g>
    <defs>
        <clipPath id="clip0_0_2846">
            <rect width="17.6757" height="17.6757" fill="white" transform="translate(0.958984 0.628418)"/>
        </clipPath>
    </defs>
</svg>


export const Icon_btn_tiket_singprod = () => <svg width={25} height={24} viewBox="0 0 25 24" fill="none"
                                                  xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_0_2020)">
        <path
            d="M22.75 6C22.75 4.9 21.85 4 20.75 4H4.75C3.65 4 2.75 4.9 2.75 6V18C2.75 19.1 3.65 20 4.75 20H20.75C21.85 20 22.75 19.1 22.75 18V6ZM20.75 6L12.75 11L4.75 6H20.75ZM20.75 18H4.75V8L12.75 13L20.75 8V18Z"
            fill="#01A3D4"/>
    </g>
    <defs>
        <clipPath id="clip0_0_2020">
            <rect width={24} height={24} fill="white" transform="translate(0.75)"/>
        </clipPath>
    </defs>
</svg>


export const Icon_btn_call_singprod = () => <svg width={25} height={24} viewBox="0 0 25 24" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_0_2017)">
        <path
            d="M18.21 5C18.15 5.89 18 6.76 17.76 7.59L18.96 8.79C19.37 7.59 19.63 6.32 19.72 5H18.21ZM8.35 17.02C7.5 17.26 6.63 17.41 5.75 17.47V18.96C7.07 18.87 8.34 18.61 9.55 18.21L8.35 17.02ZM17.25 3H20.75C21.3 3 21.75 3.45 21.75 4C21.75 13.39 14.14 21 4.75 21C4.2 21 3.75 20.55 3.75 20V16.51C3.75 15.96 4.2 15.51 4.75 15.51C5.99 15.51 7.2 15.31 8.32 14.94C8.42 14.9 8.53 14.89 8.63 14.89C8.89 14.89 9.14 14.99 9.34 15.18L11.54 17.38C14.37 15.93 16.69 13.62 18.13 10.79L15.93 8.59C15.65 8.31 15.57 7.92 15.68 7.57C16.05 6.45 16.25 5.25 16.25 4C16.25 3.45 16.7 3 17.25 3Z"
            fill="white"/>
    </g>
    <defs>
        <clipPath id="clip0_0_2017">
            <rect width={24} height={24} fill="white" transform="matrix(-1 0 0 1 24.75 0)"/>
        </clipPath>
    </defs>
</svg>






